/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::376f668afcfb1a8d49f39aed921cc2fe>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Summarize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const SummarizeIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M3.63 6.75H2.38a.63.63 0 0 1-.62-.62V4.25h1.88c.35 0 .63.28.63.63v1.25c0 .35-.28.63-.62.63m4.98-.01H7.38a.63.63 0 0 1-.62-.62V4.25h1.88c.35 0 .63.28.63.63v1.25c0 .35-.28.63-.62.63"/><path stroke="currentcolor" stroke-width="1.5" d="M3.5 1.75A1.75 1.75 0 0 0 1.75 3.5v.75m0 0v1.875c0 .345.28.625.625.625h1.25c.345 0 .625-.28.625-.625v-1.25a.625.625 0 0 0-.625-.625zm6.75-2.5A1.75 1.75 0 0 0 6.75 3.5v.75m0 0v1.875c0 .345.28.625.625.625h1.25c.345 0 .625-.28.625-.625v-1.25a.625.625 0 0 0-.625-.625zm-5.75 9h14M1 9.75h14m-3.5-3.5H15m-3.5-3.5H15"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
SummarizeIcon.displayName = 'SummarizeIcon';
var _default = exports.default = SummarizeIcon;